import { useAtomValue } from 'jotai';
import {
  hasPlayerAggsCompAndSeasonFilterParamsAtom,
  playerAggsBaseFiltersAtom,
  playerAggsFilterParamsAtom,
} from '@/atoms/queries/player/playerAggData';
import { useApplyFiltersButton } from './useApplyFiltersButton';
import { useSetMissing360DataBannerMessage } from './useSetMissing360DataBannerMessage';

export const usePlayerDataLockerApplyFiltersButton = () => {
  const hasPlayerAggsCompAndSeasonFilterParams = useAtomValue(hasPlayerAggsCompAndSeasonFilterParamsAtom);
  const setMissing360DataBannerMessage = useSetMissing360DataBannerMessage();
  return useApplyFiltersButton(
    playerAggsFilterParamsAtom,
    playerAggsBaseFiltersAtom,
    !hasPlayerAggsCompAndSeasonFilterParams,
    setMissing360DataBannerMessage,
  );
};
